import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSiteContent } from '../context/SiteContentContext';

const Services = () => {
  const { content } = useSiteContent();
  const navigate = useNavigate();

  return (
    <section id="storitve" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-[#2D4A5E] mb-4">
            {content.services_title.split(' ').slice(0, -1).join(' ')} <span className="text-[#4CAF50]">{content.services_title.split(' ').slice(-1)}</span>
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            {content.services_subtitle}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {content.services?.map((service) => (
            <div 
              key={service.id} 
              className="group cursor-pointer"
              onClick={() => navigate(`/storitev/${service.id}`)}
            >
              <div className="relative overflow-hidden rounded-lg mb-4 aspect-[4/3]">
                <img
                  src={service.image}
                  alt={service.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#2D4A5E]/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4">
                  <span className="text-white text-sm font-medium bg-[#4CAF50] px-4 py-2 rounded-full">
                    Več informacij →
                  </span>
                </div>
              </div>
              <h3 className="text-[#2D4A5E] font-bold text-lg md:text-xl text-center mb-2 group-hover:text-[#4CAF50] transition-colors">
                {service.title}
              </h3>
              <p className="text-gray-600 text-sm text-center leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
